import CategoryLeadersLabel from './CategoryLeadersLabel'

export default CategoryLeadersLabel
